/* eslint-disable react/require-default-props */
import { Article } from 'Types/ArticleTypes';
import { IsMobile, Retina125, splitArrayChunks } from 'Utils/UtilityFunctions';
import styled from 'styled-components';
import ArticleGridGlobal from './ArticleGridGlobal';
import VideoTileGlobal from './VideoTileGlobal';

const AritclesGridLayout = styled.div``;

type Props = {
  articlesArray: Article[] | null | undefined,
  listview?: boolean
};

const VideoGridLayout = function (props: Props) {
  const {
    articlesArray,
    listview = false,
  } = props;

  const isMobile = IsMobile();
  const isRes = Retina125();
  return (
    <AritclesGridLayout>
      {articlesArray && articlesArray.length > 0
        && splitArrayChunks(articlesArray, 5, isMobile, listview).map(
          (chunk, index) => {
            const isReversed = (!isMobile && !(index % 2 === 0));
            const isChunkLengthLow = chunk.length <= 4;
            return (
              <ArticleGridGlobal
                isReversed={isReversed}
                listView={listview}
                className="videoGridWrapper"
              >
                <div className="articleMainTileWrapper">
                  {!(isReversed && isChunkLengthLow) && (
                    <VideoTileGlobal
                      videoLink={isReversed
                        ? chunk[chunk.length - 1]?.videoUrl
                        : chunk[0].videoUrl}
                      videoTitle={isReversed
                        ? chunk[chunk.length - 1]?.title
                        : chunk[0].title}
                      sourceName={isReversed
                        ? chunk[chunk.length - 1]?.domain
                        : chunk[0].domain}
                      thumbnail={isReversed
                        ? chunk[chunk.length - 1]?.image
                        : chunk[0].image}
                      time={isReversed
                        ? chunk[chunk.length - 1]?.dateTimeStamp
                        : chunk[0].dateTimeStamp}
                      articleId={isReversed
                        ? chunk[chunk.length - 1]?.articleId
                        : chunk[0].articleId}
                      listView={listview}
                      gridTile
                      tileListView
                      articleWidth="530"
                      articleHeight="530"
                    />
                  )}
                </div>
                <div className="articleGridTilesWrapper">
                  {chunk.length > 0
                    // eslint-disable-next-line no-nested-ternary
                    && (isReversed
                      ? isChunkLengthLow
                        ? chunk
                        : chunk.slice(0, -1)
                      : chunk.slice(1)
                    ).map(
                      (item) => (
                        <VideoTileGlobal
                          videoLink={item.videoUrl}
                          videoTitle={item.title}
                          sourceName={item.domain}
                          thumbnail={item.image}
                          time={item.dateTimeStamp}
                          articleId={item.articleId}
                          listView={listview}
                          gridTile
                          tileListView
                          articleWidth={isRes ? '314' : '249'}
                          articleHeight={isRes ? '314' : '249'}
                        />
                      ),
                    )}
                </div>
              </ArticleGridGlobal>
            );
          },
        )}
    </AritclesGridLayout>
  );
};

export default VideoGridLayout;
